export class AuthUtils {
  static buildStandardAzureADB2CEndpoints(tenantName: string, policyName: string) {
    const baseUrl = `https://${tenantName}.b2clogin.com/${tenantName}.onmicrosoft.com/${policyName}/oauth2/v2.0`;

    return {
      authorizationBaseUrl: `${baseUrl}/authorize`,
      accessTokenEndpoint: `${baseUrl}/token`,
    };
  }
}
